import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import ResidentSidebar from '../../UserDashboard/Sidebar/ResidentSidebar';
import Topbar from '../../components/common/Topbar/Topbar';
import styles from '../DashboardLayout.module.css';
import { io } from 'socket.io-client';
import { startSiren, stopSiren } from '../../utils/siren';
import { AlertTriangle } from 'lucide-react';
import toast from 'react-hot-toast';

const SOCKET_URL = import.meta.env.VITE_API_URL ? import.meta.env.VITE_API_URL.replace(/\/api\/?$/, '') : import.meta.env.VITE_API_URL.replace(/\/api\/?$/, '');

const ResidentLayout = () => {
  const [panicAlert, setPanicAlert] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const socket = io(SOCKET_URL);

    socket.on('security_panic_alarm', (incident) => {
      setPanicAlert(incident);
      startSiren();
    });

    socket.on('new_resident_notification', (notification) => {
      toast.success(notification.message, { duration: 5000, icon: '🔔' });
      // Dispatch event so ResidentSidebar and Notifications page can re-fetch
      window.dispatchEvent(new Event('notificationUpdated'));
    });

    return () => {
      socket.disconnect();
      stopSiren();
    };
  }, []);

  const handleAcknowledge = () => {
    setPanicAlert(null);
    stopSiren();
  };

  return (
    <div className={styles.layout}>
      {panicAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          backgroundColor: 'rgba(220, 38, 38, 0.95)', zIndex: 9999,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          color: 'white', fontFamily: 'sans-serif'
        }}>
          <AlertTriangle size={100} style={{ animation: 'pulse 1s infinite' }} />
          <h1 style={{ fontSize: '4rem', margin: '20px 0', textAlign: 'center' }}>SECURITY PANIC ALARM!</h1>
          <h2 style={{ fontSize: '2rem', margin: '0 0 20px 0', textAlign: 'center' }}>{panicAlert.description || 'Emergency Triggered at Gate!'}</h2>
          <p style={{ fontSize: '1.2rem', marginBottom: '40px', maxWidth: '600px', textAlign: 'center' }}>
            Please stay indoors and await further instructions from the management or security team. Do not use the elevators.
          </p>
          <button 
            onClick={handleAcknowledge}
            style={{ padding: '20px 60px', fontSize: '1.5rem', fontWeight: 'bold', color: '#dc2626', backgroundColor: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', boxShadow: '0 10px 25px rgba(0,0,0,0.5)' }}
          >
            ACKNOWLEDGE & MUTE
          </button>
        </div>
      )}

      <ResidentSidebar mobileOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <div className={styles.mainContent}>
        <Topbar 
          onMenuClick={() => setIsSidebarOpen(true)} 
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
        <main className={styles.content}>
          <Outlet context={{ searchQuery }} />
        </main>
      </div>
    </div>
  );
};

export default ResidentLayout;
